import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import { wallet, gameController, person } from 'ionicons/icons';
import { useAuth } from '../contexts/AuthContext';
import './Home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Coin Collector</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div className="home-container">
          <div className="hero-section">
            <h1>🪙 Welcome to Coin Collector!</h1>
            <p className="subtitle">Earn coins, play games, get rewards</p>
          </div>

          <div className="quick-actions">
            {currentUser ? (
              <>
                <IonButton
                  expand="block"
                  color="primary"
                  onClick={() => navigate('/wallet')}
                  className="action-button"
                >
                  <IonIcon icon={wallet} slot="start" />
                  My Wallet
                </IonButton>

                <IonButton
                  expand="block"
                  color="primary"
                  onClick={() => navigate('/games')}
                  className="action-button"
                >
                  <IonIcon icon={gameController} slot="start" />
                  Play Games
                </IonButton>
              </>
            ) : (
              <IonButton
                expand="block"
                color="primary"
                onClick={() => navigate('/login')}
                className="action-button"
              >
                <IonIcon icon={person} slot="start" />
                Sign In to Get Started
              </IonButton>
            )}

            {currentUser ? (
              <IonButton
                expand="block"
                fill="outline"
                color="primary"
                onClick={() => navigate('/dashboard')}
                className="action-button"
              >
                <IonIcon icon={person} slot="start" />
                Go to Dashboard
              </IonButton>
            ) : (
              <IonButton
                expand="block"
                fill="outline"
                color="primary"
                onClick={() => navigate('/login')}
                className="action-button"
              >
                <IonIcon icon={person} slot="start" />
                Sign In / Sign Up
              </IonButton>
            )}
          </div>

          <div className="info-section">
            <h2>How to Earn Coins</h2>
            <ul className="earn-list">
              <li>🎮 Play mini-games</li>
              <li>📺 Watch ads</li>
              <li>👥 Invite friends</li>
              <li>⏰ Daily bonuses</li>
            </ul>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
